import {ContactCategory} from "../../enum/contact-category.enum";
import {ContactType} from "../../enum/contact-type";
import {isDefined} from "../../utils/epic.utils";
import {AbstractFormConfig} from "../abstract-form.config";

export class FormContactConfig extends AbstractFormConfig {

  public addNewContact: boolean = false;
  public addNewContactType: ContactType | undefined = undefined;
  public addNewContactCategory: ContactCategory | undefined = undefined;
  public employeeTypeSelectShow: boolean = false;
  public employeeTypeSelectDisabled: boolean = false;
  // Filter
  /** @deprecated use filterCategory instead */
  public category: ContactCategory | undefined = undefined;
  public filterCategory: ContactCategory | undefined = undefined;
  public filterType: ContactType | undefined = undefined;

  constructor(init?: Partial<FormContactConfig> | undefined) {
    super(init);
    Object.assign(this, init);
  }

  public static buildAllConfig(init?: Partial<FormContactConfig> | undefined): FormContactConfig {
    const config = new FormContactConfig(init);
    config.addNewContact = isDefined(init?.addNewContact) ? init.addNewContact : true;
    config.addNewContactType = undefined;
    config.addNewContactCategory = undefined;
    config.category = undefined;
    return config;
  }

  public static buildCreditorConfig(init?: Partial<FormContactConfig> | undefined): FormContactConfig {
    const config = new FormContactConfig(init);
    config.addNewContact = isDefined(init?.addNewContact) ? init.addNewContact : true;
    config.addNewContactType = ContactType.COMPANY;
    config.addNewContactCategory = ContactCategory.CREDITOR;
    config.category = ContactCategory.CREDITOR;
    return config;
  }

  public static buildEmployeeConfig(init?: Partial<FormContactConfig> | undefined): FormContactConfig {
    const config = new FormContactConfig(init);
    config.addNewContact = isDefined(init?.addNewContact) ? init.addNewContact : true;
    config.addNewContactType = ContactType.PERSON;
    config.addNewContactCategory = ContactCategory.EMPLOYEE;
    config.category = ContactCategory.EMPLOYEE;
    return config;
  }
}
